const GET_VENDOR_EMAIL_HISTORY = "GET_VENDOR_EMAIL_HISTORY" 
const SET_VENDOR_EMAIL_HISTORY = "SET_VENDOR_EMAIL_HISTORY"

const GET_VENDOR_EMAIL_HISTORY_MESSAGE = "GET_VENDOR_EMAIL_HISTORY_MESSAGE"
const SET_VENDOR_EMAIL_HISTORY_MESSAGE = "SET_VENDOR_EMAIL_HISTORY_MESSAGE"

export {
    GET_VENDOR_EMAIL_HISTORY,
    SET_VENDOR_EMAIL_HISTORY,
    GET_VENDOR_EMAIL_HISTORY_MESSAGE,
    SET_VENDOR_EMAIL_HISTORY_MESSAGE
}